import React, { FC, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { ApiDispatchState } from '@dew21/ui';
import axios from 'axios';

export const ApiDispatchHandler: FC = ({ children }) => {
  const [apiDispatchState, setApiDispatchState] = useRecoilState(ApiDispatchState);
  useEffect(() => {

    if (!apiDispatchState.loading) {
      if (apiDispatchState.queue.length > 0) {
        const [ queued, ...nextQueue ] = apiDispatchState.queue;
        setApiDispatchState({
          loading: true,
          queue: nextQueue,
        });
        (axios as any)[queued.method](queued.route, ['get', 'delete'].includes(queued.method) ? queued.header : queued.body, queued.header).then((res: any) => {
          setApiDispatchState({
            loading: false,
            queue: nextQueue,
          });
          if (queued.onSuccess) {
            queued.onSuccess(res);
          }
        }).catch((err: any) => {
          setApiDispatchState({
            loading: false,
            queue: nextQueue,
          });
          if (queued.onFailure) {
            queued.onFailure(err);
          }
        });
      }
    }

  }, [apiDispatchState]);

  return (
    <>{ children }</>
  );
}
